const defaultState = {
  trails: {},

  list: [],

  page: 1,
  loading: false,
  coursesLoading: false,
  hasMore: true,
  available: true,

  currentTrail: null,
  currentTrailCourses: null,
  courseList: null
};

export function trails(state = defaultState, action) {
  switch (action.type) {
    case 'GET_ALL_COURSES': {
      return {
        ...state,
        coursesLoading: true
      };
    }
    case 'GET_ALL_COURSES_SUCCESS': {
      return {
        ...state,
        courseList: action.courseList,
        coursesLoading: false
      };
    }
    case 'GET_TRAILS_REQUEST': {
      return {
        ...state,
        loading: true
      };
    }
    case 'GET_TRAILS_SUCCESS': {
      const newList =
        action.page === 1 ? action.trails : [...state.list, ...action.trails];

      return {
        ...state,
        list: newList,
        page: action.page,
        loading: false,
        hasMore: action.trails.length === 10
      };
    }

    case 'GET_TRAILS_RESET': {
      return {
        ...state,
        list: [],
        page: 1,
        hasMore: true
      };
    }
    case 'UPDATE_TRAIL_AVAILABLE_REQUEST': {
      return {
        ...state,
        loading: true
      };
    }
    case 'UPDATE_TRAIL_AVAILABLE_SUCCESS': {
      return {
        ...state,
        loading: false
      };
    }
    case 'CREATE_TRAIL': {
      return {
        ...state,
        currentTrail: action.trail
      };
    }
    case 'UPDATE_TRAIL': {
      return {
        ...state,
        trails: action.trails
      };
    }
    case 'DELETE_TRAIL': {
      return {
        ...state,
        trails: action.trails
      };
    }
    case 'GET_CURRENT_TRAIL_COURSES': {
      return {
        ...state,
        currentTrail: action.trail.trail,
        currentTrailCourses: action.trail
      };
    }
    case 'ADD_COURSE_TO_TRAIL': {
      return {
        ...state,
        trails: action.trails
      };
    }
    case 'REMOVE_COURSE_FROM_TRAIL': {
      return {
        ...state,
        trails: action.trails
      };
    }
    case 'CLEAR_CURRENT_TRAIL':
      return {
        ...state,
        currentTrail: null
      };
    default:
      return state;
  }
}
